import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Constants from '../../../constants';

type Props = {
  authed: boolean;
  userId?: string;
  displayedTitle: string;
  onOpenTitle: () => void;
  onLogin: () => void | Promise<void>;
  onLogout: () => void;
  onToggleSidebar: () => void;
  onNewChat: () => void;
};

export function TopBar({
  authed, userId, displayedTitle, onOpenTitle, onLogin, onLogout, onToggleSidebar, onNewChat
}: Props) {
  const { t } = useTranslation();

  return (
    <div style={{ 
      position: 'sticky',
      top: 0,
      zIndex: 10,
      display: 'flex', 
      alignItems: 'center', 
      gap: 12, 
      padding: '10px 12px', 
      borderBottom: '1px solid #eee', 
      background: '#f7f7f7' 
    }}>
      <button onClick={onToggleSidebar} title="Toon chats" style={{ padding: 6, borderRadius: 8, border: '1px solid #ddd', background: '#fff' }}>☰</button>
      <div style={{ flex: 1, minWidth: 0 }}>
        <button onClick={onOpenTitle} title="Titel bewerken" style={{ border: 0, background: 'transparent', padding: 0, cursor: 'pointer' }}>
          <h1 style={{ margin: 0, fontSize: 18, color: Constants.COLOR_BOMA_BLUE, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{displayedTitle}</h1>
        </button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {authed ? (
          <button onClick={onLogout} style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', background: '#fff' }}>{t('chat.topbar.logout')}</button>
        ) : (
          <button onClick={onLogin} style={{ padding: '8px 10px', borderRadius: 8, border: 0, background: Constants.COLOR_BOMA_BLUE, color: '#fff' }}>{t('chat.topbar.login')}</button>
        )}
      </div>
      <button onClick={onNewChat} style={{ padding: '8px 10px', borderRadius: 8, border: 0, background: Constants.COLOR_BOMA_BLUE, color: '#fff' }}>{t('chat.topbar.newChat')}</button>
    </div>
  );
}